import React, { useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import FooterMenuPage from "../../Container/pages/FooterMenuPage";
import { useGetFooterMenusDataQuery } from "../../../redux/services/internal/apiHome";
import { flattenMenus } from "../../../Utility/FlattenMenu";

const FooterMenuRoutes = ({ benchId }) => {
  const { data: fetchFooterMenus = {} } = useGetFooterMenusDataQuery(benchId, {
    refetchOnMountOrArgChange: true,
  });

  const transformedDataFooter = useMemo(() => {
    return fetchFooterMenus.data ? flattenMenus(fetchFooterMenus.data) : [];
  }, [fetchFooterMenus.data]);
  return (
    <Routes>
      {transformedDataFooter?.map((item, index) => (
        <Route
          key={index}
          path={item.slug}
          element={<FooterMenuPage benchId={benchId} />}
        ></Route>
      ))}
    </Routes>
  );
};

export default FooterMenuRoutes;
